// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsWrapper__root--2PQR5"};